
import { defineComponent } from 'vue';
import LogoLimaTec from './LogoLimaTec.vue';
import { abreWhatsApp } from '@/uteis/contato';
import { rolarPara } from '@/uteis/navegacao';
import { conteudoSite, telefoneLink } from '@/uteis/conteudo';

const SECOES = ['empresa', 'servicos', 'orcamento', 'contato'];

export default defineComponent({
  name: 'MenuHorizontal',
  props: {
    TextoWhatsApp: {
      type: String,
      default: ""
    },
    temaEscuro: {
      type: Boolean,
      default: true
    }
  },
  emits: ['alternar-tema'],
  components: {
    LogoLimaTec
  },
  data() {
    return {
      menuAberto: false,
      rolado: false,
      escondido: false,
      secaoAtiva: '',
      ultimoY: 0
    };
  },
  computed: {
    telefone(): string { return conteudoSite.contato.telefone; },
    telefoneHref(): string { return telefoneLink(); }
  },
  mounted() {
    window.addEventListener('scroll', this.aoRolar, { passive: true });
    this.aoRolar();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.aoRolar);
  },
  methods: {
    abrirWhatsApp() {
      abreWhatsApp(this.TextoWhatsApp, 'Menu');
    },
    irPara(id: string) {
      this.menuAberto = false;
      rolarPara(id);
    },
    aoRolar() {
      const y = window.scrollY;
      this.rolado = y > 8;

      // auto-esconder (só tem efeito no celular, via CSS):
      // descendo esconde, subindo mostra
      this.escondido = !this.menuAberto && y > 140 && y > this.ultimoY;
      this.ultimoY = y;

      this.atualizarSecaoAtiva();
    },
    atualizarSecaoAtiva() {
      // no topo da página nenhum item fica aceso
      let atual = '';
      for (const id of SECOES) {
        const secao = document.getElementById(id);
        if (secao && secao.getBoundingClientRect().top <= 130) {
          atual = id;
        }
      }
      // chegou ao fim da página: marca a última seção
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 80) {
        atual = SECOES[SECOES.length - 1];
      }
      this.secaoAtiva = atual;
    }
  }
});
